// extracted by mini-css-extract-plugin
var _1 = "bvcCN";
export { _1 as "canvas" }
